import React from "react";
import { HomeTemplate } from "../../Templates/HomeTemplate";

export const Home = () => {
  return <HomeTemplate />;
};
